import useInBreakpoint from "./useInBreakpoint";
import useIsLandscape from "./useIsLandscape";

export default function useIsMobile(){
    const isMobile = useInBreakpoint(0, useIsLandscape());
    return isMobile
};